import { render } from "./uni_input_fields_painter.vue?vue&type=template&id=7f8f63de"
import script from "./uni_input_fields_painter.vue?vue&type=script&lang=js"
export * from "./uni_input_fields_painter.vue?vue&type=script&lang=js"

import "./uni_input_fields_painter.vue?vue&type=style&index=0&id=7f8f63de&lang=less"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__